import { Link } from "react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useCharger } from "./charger";
import { euros, dateHeure } from "./api";

/* Mini tableau de bord de chacun (19/10/2026), en tête de l'accueil du CRM. */
const ETAPES: Record<string, string> = { won: "Gagnée", paid: "Payée" };

const Chiffre = ({ l, v, sous }: { l: string; v: React.ReactNode; sous?: string }) => (
  <div className="rounded-md border p-3">
    <p className="text-xs font-semibold uppercase text-muted-foreground">{l}</p>
    <p className="text-2xl font-bold">{v}</p>
    {sous && <p className="text-xs text-muted-foreground">{sous}</p>}
  </div>
);

export function MesChiffres() {
  const { data: d } = useCharger<any>("/api/simulateur/mes-chiffres");
  if (!d) return null;
  return (
    <Card className="mb-6">
      <CardHeader><CardTitle>Mes chiffres</CardTitle></CardHeader>
      <CardContent className="space-y-4 text-sm">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-6">
          <Chiffre l="Appels ce mois" v={d.appels.mois} sous={`${d.appels.total} au total`} />
          <Chiffre l="Mails envoyés ce mois" v={d.mails.mois} sous={`${d.mails.total} au total`} />
          <Chiffre l="Affaires en cours" v={d.en_cours.n} sous={euros(d.en_cours.montant)} />
          <Chiffre l="Dossiers closés" v={d.closes.n} sous={euros(d.closes.montant)} />
          <Chiffre l="Dossiers payés" v={d.payes.n} sous={euros(d.payes.montant)} />
          <Chiffre l={`Ma commission (${d.taux} %)`} v={euros(d.commission.sur_payes)} sous={`${euros(d.commission.totale)} en comptant les closés non payés`} />
        </div>
        {d.dossiers.length > 0 ? (
          <div>
            <p className="mb-1 font-semibold">Suivi de mes dossiers closés</p>
            <ul className="space-y-1">
              {d.dossiers.map((x: any) => (
                <li key={x.id}>
                  <Link className="underline" to={`/deals/${x.id}/show`}>{x.nom}</Link> · {euros(x.montant)} · <strong>{ETAPES[x.etape] || x.etape}</strong> · commission {euros(x.commission)} · mis à jour {dateHeure(x.maj)}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <p className="text-muted-foreground">
            Aucun dossier closé pour l'instant. Quand une affaire est signée, passez-la en « Gagnée » dans Affaires, puis en « Payée » une fois le client payé : votre commission se calcule seule.
            Après chaque appel, cliquez « Appel passé » sur la fiche du contact : c'est ce qui compte vos appels.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
